import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Paginator from './Paginator/';
import './styles.css';

export default class Table extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
  }

  componentWillMount() {
    var sortTypes = {};
    (this.getMetaData()).forEach((columnKey, columnIndex) => {
      sortTypes[columnIndex] = 'default';
    });
    this.setState({sortTypes});
  }

  getMetaData = () => {
    if(this.props.useObjectKeys && this.props.data.length !==0 ) {
      return this.props.data.length !== 0 ? Object.keys(this.props.data[0]) : [];
    }else {
      return this.props.tableMeta ? this.props.tableMeta.map(meta => meta.displayName) : [];
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({data: nextProps.data});
  }

  sortColumn = (columnIndex) => {
    this.setState(prevState => {
      if(prevState.sortTypes[columnIndex] === 'default'){
        return {sortTypes: {...prevState.sortTypes, [columnIndex]: 'asce'}}
      }else if(prevState.sortTypes[columnIndex] === 'asce') {
        return {sortTypes: {...prevState.sortTypes, [columnIndex]: 'desc'}}
      }else if(prevState.sortTypes[columnIndex] === 'desc') {
        return {sortTypes: {...prevState.sortTypes, [columnIndex]: 'asce'}}
      }
    }, () =>{
      if(this.state.data.length !== 0) {
        this.sortData(columnIndex, this.state.sortTypes[columnIndex], this.props.tableMeta[columnIndex].defaultValue);
      }
    });
  }

  sortData = (columnIndex, sortType, defaultValue = 'z') => {
    var stringSort = function(a, b) {
      let nameA = a[recordKeys[columnIndex]] !== undefined ? a[recordKeys[columnIndex]].toUpperCase() : defaultValue;
      let nameB = b[recordKeys[columnIndex]] !== undefined ? b[recordKeys[columnIndex]].toUpperCase() : defaultValue;
      if(sortType === 'asce') {
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      }else if (sortType === 'desc') {
        if (nameA > nameB) {
          return -1;
        }
        if (nameA < nameB) {
          return 1;
        }
        return 0;
      }
    };
    var dateSort = function(a, b) {

    }
    var numberSort = function(a, b) {

    }
    var comparator = stringSort;
    if(this.props.useObjectKeys === false && this.props.tableMeta && this.props.tableMeta[columnIndex].type) {
      if(this.props.tableMeta[columnIndex].type.toLowerCase() === 'date'){
        comparator = dateSort;
      }else if(this.props.tableMeta[columnIndex].type.toLowerCase() === 'date') {
        comparator = numberSort;
      }else if(this.props.tableMeta[columnIndex].type.toLowerCase() === 'custom') {
        comparator = this.props.tableMeta[columnIndex].comparator;
      }
    }
    let recordKeys = [];
    if(this.props.useObjectKeys === false && this.props.tableMeta && this.props.tableMeta[columnIndex].key) {
      recordKeys = this.props.tableMeta.reduce((accumulator, element) => accumulator.concat(element.key), []);
    }else {
      recordKeys = Object.keys(this.state.data[0]);
    }

    const sortedData = ([].concat(this.state.data)).sort(comparator);
    this.setState({data: sortedData}, ()=> {
      if(this.props.usePagination){
        this.paginator.changePage();
      }
    });
  }

  onPageSizeChange = (visibileData) => {
    this.setState({visibileData});
  }

  render() {
    const metaData = this.getMetaData();
    const headerJsx = metaData.map((columnValue, columnIndex) => {
      return(<th key={columnIndex} onClick={(event) => this.sortColumn(columnIndex)}>
      {columnValue}
      <i className="icon icon-chevron-down pull-right sort-icon"></i>
      </th>)
    });
    let recordsJsx = "";
    if(this.props.useObjectKeys) {
      recordsJsx = (this.state.visibileData || this.state.data).map((record, index) => {
        let cols = [];
        for(let colIndex in record) {
          cols.push(<td key={colIndex}>{record[colIndex]}</td>);
        }
        return <tr key={index}>{cols}</tr>;
      });
    }else {
      recordsJsx = (this.state.visibileData || this.state.data).map((record, index) => {
        let cols = [];
        this.props.tableMeta.forEach((meta) => {
          if(record[meta.key] === undefined || record[meta.key] === "" || record[meta.key] === null) {
            cols.push(<td key={meta.key}>{meta.defaultValue || "N/A"}</td>);
          }else if(meta.type === undefined) {
            // treating value as string
            cols.push(<td key={meta.key}>{record[meta.key].toString()}</td>);
          }else if(meta.type.toLowerCase() === "string") {
            cols.push(<td key={meta.key}>{record[meta.key].toString()}</td>);
          }else if(meta.type.toLowerCase() === "boolean") {
            const _dvalue = record[meta.key] === true ? "Yes" : "No";
            cols.push(<td key={meta.key}>{_dvalue}</td>);
          }else if(meta.type.toLowerCase() === "custom" && meta.displayValueComputer) {
            cols.push(<td key={meta.key}>{meta.displayValueComputer(record[meta.key])}</td>);
          }else {
            // default fallback to string
            cols.push(<td key={meta.key}>{record[meta.key].toString()}</td>);
          }
        });
        return <tr key={index}>{cols}</tr>;
      });
    }
    return (
      <div>
      <table className="gdocs-table">
      <thead>
      <tr>
      {headerJsx}
      </tr>
      </thead>
      <tbody>
      {recordsJsx}
      </tbody>
      </table>
      {this.props.usePagination && this.props.data ? (<Paginator ref={instance => { this.paginator = instance }} data={this.state.data} onPageSizeChange={this.onPageSizeChange} pageSizes={this.props.pageSizes} />) : ''}
      </div>
    )
  }
}

Table.defaultProps = {
  useObjectKeys: false,
  usePagination: false,
  pageSizes: [20, 50]
}

Table.propTypes = {
  data: PropTypes.array.isRequired,
  useObjectKeys: PropTypes.bool,
  metaData: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    type: PropTypes.number.isRequired,
    comparator: PropTypes.func
  }),
  usePagination: PropTypes.bool,
  pageSizes: PropTypes.array
}



// WEBPACK FOOTER //
// ./src/components/common/Table/index.js